import * as React from 'react';

import Illustration, { IllustrationColorProps } from './Illustration';

export const IllustrationEvents: React.FunctionComponent<IllustrationColorProps> = ({ color }) => {
  return (
    <Illustration
      color={color}
      strokes={
        <>
          <path d="M35.834 15.8744L44.2594 10.8908C44.9994 10.4583 45.9486 10.6896 46.4082 11.4145L48.3741 14.499" />
          <path d="M15.9623 49.3437L17.768 52.563C18.2172 53.2983 19.1673 53.5446 19.9158 53.1187L30.1132 47.4688" />
          <path d="M16.7601 21.3071L36.2743 18.9725" />
          <path d="M46.1509 17.4687L50.9485 17.0097C51.8113 16.8903 52.6095 17.4864 52.7427 18.3486L53.6981 24.0312" />
          <path d="M55.1132 32.9375L55.8082 39.3208C55.9245 40.1905 55.3196 40.9916 54.4539 41.1157L48.9295 41.9064" />
          <path d="M39.9692 43.3995L12.9019 46.9395C12.0381 47.0523 11.2436 46.4496 11.118 45.5855L10.3019 39.5" />
          <path d="M8.8868 30.5938L8.1911 24.3568C7.96942 22.7755 9.97793 22.1355 11.9483 21.9848" />
          <path d="M43.9014 17.7328C44.0955 19.066 43.1745 20.3052 41.8445 20.4999C40.5146 20.6945 39.2784 19.7712 39.0842 18.4379" />
          <path d="M42.47 43.2734C42.2758 41.9402 43.1969 40.7009 44.5268 40.5063C45.8568 40.3117 47.093 41.235 47.2871 42.5682" />
          <path d="M55.0691 31.2041C53.7392 31.3987 52.503 30.4754 52.3089 29.1421C52.1147 27.8089 53.0357 26.5696 54.3657 26.375" />
          <path d="M8.8868 32.9634C10.2168 32.7688 11.4529 33.6921 11.6471 35.0253C11.8412 36.3586 10.9202 37.5978 9.59023 37.7925" />
          <path d="M43.6566 36.1935L43.8903 38.0255" />
          <path d="M43.1056 31.7556L43.322 33.6953" />
          <path d="M42.5441 27.2245L42.7536 29.2521" />
          <path d="M41.9738 22.6258L42.2231 24.8465" />
        </>
      }
      shadows={
        <>
          <path d="M45.1444 10.5811L29.1233 19.7088L39.1471 18.5835L40.1117 20.1672L42.1668 20.2506L43.5509 19.2086L43.8445 17.6249L49.5484 16.9997L46.1512 11.123L45.1444 10.5811Z" />
          <path d="M18.2369 53.0664L14.4693 46.6727L35.6389 44.1501L42.4082 43.1664L43.0788 41.3578L44.5795 40.628L46.8625 41.215L47.4532 42.2304L55.1164 40.9453L56.0744 38.7876L56.6769 42.5185C56.8033 43.3011 56.2797 44.0408 55.4996 44.1818L44.8349 45.5145L30.0832 47.5452L27.5366 48.759L19.4343 53.3679L18.2369 53.0664Z" />
        </>
      }
      dots={
        <>
          <circle cx="17.9366" cy="35.7058" r="0.9" />
          <circle cx="21.3754" cy="34.8052" r="0.9" />
          <circle cx="20.7059" cy="31.3221" r="0.9" />
          <circle cx="17.1591" cy="30.0308" r="0.9" />
          <circle cx="22.4915" cy="27.9018" r="0.9" />
          <circle cx="25.913" cy="29.925" r="0.9" />
          <circle cx="25.2477" cy="33.8381" r="0.9" />
          <circle cx="23.1466" cy="38.4304" r="0.9" />
          <circle cx="18.1672" cy="39.3981" r="0.9" />
          <circle cx="27.5253" cy="37.7187" r="0.9" />
          <circle cx="31.2293" cy="37.0037" r="0.9" />
          <circle cx="34.2041" cy="39.3981" r="0.9" />
          <circle cx="34.7179" cy="34.8468" r="0.9" />
          <circle cx="29.5669" cy="33.3137" r="0.9" />
          <circle cx="33.6227" cy="31.0993" r="0.9" />
          <circle cx="29.6894" cy="29.3092" r="0.9" />
          <circle cx="33.0881" cy="27.1026" r="0.9" />
          <circle cx="28.4253" cy="25.4743" r="0.9" />
        </>
      }
    />
  );
};

export default IllustrationEvents;
